export const fieldCannotBeBlankErrorMessage = 'This field cannot be blank';

export const TIME_UNIT_OPTIONS = [
  { label: 'Days', key: 'DAYS' },
  { label: 'Weeks', key: 'WEEKS' },
  { label: 'Months', key: 'MONTHS' },
  { label: 'Years', key: 'YEARS' },
];
